import { useEffect, useState, useCallback, useMemo } from "react";
import {
  LinkOccupantDropdown,
  RequsetTypeDropdown,
  SelectUserCheckboxDropdown,
} from "components";
import SC from "./style";
import { apiGet, apiPost } from "api/callApi";
import { Checkbox, List } from "@mui/material";
import theme from "theme";
import { useSearchParams } from "react-router-dom";
import TimezoneConverter from "components/TimeZoneConvertor";
import { getUpdateRequest } from "utils/helper";

const RequestContent = ({ setData, data, intitalRequestType, journalData }) => {
  const [roles, setRoles] = useState([]);
  const [userData, setUserData] = useState([]);
  const [requestHold, setRequestHold] = useState(false);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const isReply = searchParams.get("isReply");
  const [emailString, setEmailString] = useState();

  const roleProjectIds = useMemo(() => {
    if (type != 1) {
      return projectId;
    }

    const linkedOccupants = Array.isArray(data?.linktoproject)
      ? data.linktoproject
      : [data?.linktoproject];

    return [...new Set([projectId, ...linkedOccupants].filter(Boolean))];
  }, [data?.linktoproject, projectId, type]);

  // Fetch roles data on mount
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        // const response = await apiGet("/v1/roles?active=true", false);

        const response = await apiPost(
          `/v1/options/getroles?active=${true}`,
          {
            projectId: roleProjectIds,
            projectType: type,
          },
          false,
        );

        //console.log(response, "sd");
        setRoles(response.data);
        // if (!isReply) {
        //   const apiRoles = response.data || [];
        //   const filteredRoles = apiRoles.filter((role) => {
        //     return data.rolesData?.some(
        //       (r) => r.roleId == role.roleId && !r.replied
        //     );
        //   });
        //   setRoles(filteredRoles);

        // }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, [roleProjectIds, type]);

  // Handle general changes
  const handleChange = (property, value, emails) => {
    //console.log(property, value, emails, "onchange");

    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));

    if (property === "requestType") {
      if (value == 1 || value == 2) {
        setData((prevData) => ({
          ...prevData,
          users: [],
          roles: [],
          // secondaryalarm: {
          //   alarmTo: undefined,
          //   active: 0,
          //   alarmType: 1,
          // },
          sendTo: undefined,
        }));
      }
    }

    if (property === "users") {
      setData((prevData) => ({
        ...prevData,
        // secondaryalarm: {
        //   alarmTo: emails,
        //   active: 0,
        //   alarmType: 1,
        // },
        sendTo: emails,
      }));
    }
  };

  useEffect(() => {
    setData((prevData) => ({
      ...prevData,
      sendTo: emailString,
    }));
  }, [emailString]);

  // Handle role selection changes
  const onSelectionChange = useCallback(
    (roleId) => {
      // Update roles by toggling the selected role
      const updatedRoles = data.roles?.includes(roleId)
        ? data.roles.filter((id) => id !== roleId) // Remove the role if it exists
        : [...(data.roles || []), roleId]; // Add the role if it doesn't exist

      const filteredUsers = (data.users || []).filter(
        (userId) =>
          userData.includes(userId) &&
          updatedRoles.some((role) => role == roleId) // Ensure user is associated with selected roles
      );

      // Update the state with updated roles and filtered users
      setData((prevData) => ({
        ...prevData,
        roles: updatedRoles,
        users: filteredUsers,
      }));
    },
    [data.roles, data.users, setData, userData]
  );

  // Handle checkbox toggle for request hold
  const handleCheckboxChange = useCallback(
    (e) => {
      const isChecked = e.target.checked ? 1 : 0;
      setRequestHold(isChecked);
      setData((prevData) => ({
        ...prevData,
        requestType: isChecked
          ? intitalRequestType
          : getUpdateRequest(intitalRequestType),
        requestHold: isChecked,
      }));
    },
    [intitalRequestType, setData]
  );

  const selectRole = useMemo(
    () => (!isReply ? roles.map((x) => x.roleId) : data.roles),
    [isReply, roles, data.roles]
  );

  return (
    <div>
      <SC.ContainerStyle>
        <SC.ITalicSpan>
          <SC.Italic>
            Please note that the journal will be automatically closed if no
            request/include in report is selected and no alarm has been created.
          </SC.Italic>
        </SC.ITalicSpan>
      </SC.ContainerStyle>

      <SC.LabelContainer>
        <SC.Label>
          Request Type<SC.Astrik>*</SC.Astrik>
        </SC.Label>
        <SC.Children>
          <SC.Wrapper style={{ alignItems: "center" }}>
            <RequsetTypeDropdown
              defaultValue={data?.requestType}
              name="requestType"
              onChange={handleChange}
              disabledDropdown={data?.requestHold}
              update={!isReply}
            />
            {!isReply && (
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Checkbox
                  checked={requestHold}
                  onChange={handleCheckboxChange}
                  sx={{
                    "&.Mui-checked": {
                      color: theme.colors.themeColor,
                    },
                  }}
                  size="small"
                />
                <SC.RequestHold>Request Hold</SC.RequestHold>
              </div>
            )}
          </SC.Wrapper>
        </SC.Children>
      </SC.LabelContainer>

      {!isReply && (
        <SC.CardContainerStyle>
          <SC.TableContainer>
            <SC.Table>
              <SC.Thead>
                <SC.Tr>
                  <SC.Th>Role</SC.Th>
                  <SC.Th>Replied?</SC.Th>
                  <SC.Th>Replied On</SC.Th>
                </SC.Tr>
              </SC.Thead>
              <SC.Tbody>
                {data?.rolesData?.length ? (
                  data.rolesData.map((role, index) => (
                    <SC.Tr key={index}>
                      <SC.Td>{role.roleName}</SC.Td>
                      <SC.Td>
                        {role.replied ? (
                          <SC.Yes>Yes</SC.Yes>
                        ) : (
                          <SC.No>No</SC.No>
                        )}
                      </SC.Td>
                      <SC.Td>
                        <TimezoneConverter
                          time={role?.replied ? role.repliedOn : ""}
                        />
                      </SC.Td>
                    </SC.Tr>
                  ))
                ) : (
                  <SC.Tr>
                    <SC.NoData colSpan={3}>No Data</SC.NoData>
                  </SC.Tr>
                )}
              </SC.Tbody>
            </SC.Table>
          </SC.TableContainer>
        </SC.CardContainerStyle>
      )}

      {!(data?.requestType === 1 || data?.requestType === 2) && (
        <>
          <SC.LabelContainer>
            <SC.Label>
              Select Role/s<SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <List
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {roles.map((role) => (
                    <label
                      key={role.roleId}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Checkbox
                        checked={data?.roles?.includes(role.roleId) || false}
                        onChange={() => onSelectionChange(role.roleId)}
                        sx={{
                          "&.Mui-checked": { color: theme.colors.themeColor },
                        }}
                        size="small"
                      />
                      <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                        {role.role}
                      </span>
                    </label>
                  ))}
                </List>
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>

          <SC.LabelContainer>
            <SC.Label>
              Select User <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <SelectUserCheckboxDropdown
                  onChange={handleChange}
                  defaultValue={data?.users}
                  placeholder="Select user"
                  projectId={journalData?.projectId}
                  linkedProjectIds={roleProjectIds}
                  type={journalData?.projectType}
                  selectRole={data.roles}
                  name="users"
                  setUserData={setUserData}
                  setEmailString={setEmailString}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        </>
      )}
    </div>
  );
};

export default RequestContent;
